var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { TextField } from '@material-ui/core';
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  position: relative;\n  ", "\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  position: relative;\n  ", "\n"])), function (props) { return (props.half ? "width: 49.3%" : ""); });
export var LabeledInput = styled(TextField)({
    '&&': {
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: "translate(0px, -15px) scale(0.75)"
        },
        '& .MuiSelect-icon': {
            color: '#ffffff',
            backgroundColor: '#757575',
            width: 18,
            height: 18,
            borderRadius: 2,
            top: '50%',
            transform: 'translateY(-50%)'
        }
    }
});
var templateObject_1;
//# sourceMappingURL=TopLabeledTextField.Styles.js.map